const API_URL = 'https://app.thundermaxhome.com/api.php';
const UPLOAD_URL = 'https://app.thundermaxhome.com/upload.php';

export const saveToSyncQueue = (action, payload) => {
  const queue = JSON.parse(localStorage.getItem('syncQueue') || '[]');
  queue.push({ id: Date.now(), action, payload });
  localStorage.setItem('syncQueue', JSON.stringify(queue));
};

export const getSyncQueue = () => {
  return JSON.parse(localStorage.getItem('syncQueue') || '[]');
};

export const clearSyncQueueItem = (id) => {
  const queue = getSyncQueue();
  const newQueue = queue.filter(item => item.id !== id);
  localStorage.setItem('syncQueue', JSON.stringify(newQueue));
};

export const processSyncQueue = async () => {
  if (!navigator.onLine) return;
  
  const queue = getSyncQueue();
  if (queue.length === 0) return;

  console.log(`[Sync] Processing ${queue.length} items...`);
  
  for (const item of queue) {
    try {
      if (item.action === 'upload_image') {
        // payload: { jobId, type, base64 }
        const res = await fetch(UPLOAD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image_base64: item.payload.base64 })
        });
        const result = await res.json();
        
        if (result.success) {
          // Update the job with the real URL
          await fetch(`${API_URL}?action=update_job`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.payload.jobId, [item.payload.type]: result.url })
          });
          clearSyncQueueItem(item.id);
        }
      } else if (item.action === 'update_job') {
        const res = await fetch(`${API_URL}?action=update_job`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item.payload)
        });
        const result = await res.json();
        if (result.success) {
          clearSyncQueueItem(item.id);
        }
      }
    } catch (error) {
      console.error('[Sync] Error processing item:', item, error);
      if (!navigator.onLine) break; 
    }
  }
};
